import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardClaimsRoutingModule } from './dashboard-claims-routing.module';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { DashboardClaimsService } from './dashboard-claims.service';
import { DashboardClaimsComponent } from './dashboard-claims.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
    DashboardClaimsRoutingModule,
    AgGridModule,
    FormsModule,
    DirectivesModule,
    MyDateRangePickerModule
  ],
  declarations: [DashboardClaimsComponent],
  providers: [DashboardClaimsService]
})
export class DashboardClaimsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-claims/dashboard-claims.module.ts